export default __webpack_public_path__ + "static/image-17-9af9a7f0369c7d033cc6887de8e53ea1.jpg";